import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface InventoryParams extends ApiParameter {
    productId: string;
}

export interface WarehouseModal {
       uri: null;
    natInv: string;
    returnCode: string;
    returnMessage: string;
    warehouseInventoryRespList: WarehouseInventoryRespList[];
    properties: any;
}

export interface WarehouseInventoryRespList {
    dc: string;
    inventory: number;
    warehouse: Warehouse;
}

export interface Warehouse {
    id: string;
    name: string;
    description: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    postalCode: string;
    contactName: string;
    phone: string;
    shipSite: string;
    deactivateOn: null;
    isDefault: boolean;
    countryId: string;
}

const getInventorysUrl = "/api/v1/getinventory";

export function getInventory(parameter: InventoryParams) {
    return get<WarehouseModal>(`${getInventorysUrl}/`, parameter as any);
}